import type { FaireProductEntity } from "../../entity_types/product";

export const p_326x2kvahq: FaireProductEntity = {
  token: "p_326x2kvahq",
  type: "product",
  name: "Luxe Body and Hair Oil",
  brandToken: "b_ad8bjvlw5g",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b692884f8ffe5ebeb520d2fac74354154d8154520d878a797f24743c797d87f5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ac36a968adac6ae05c710a876cc8e38a7d0b1af08e98912baee56a399395267e.jpeg",
    "https://cdn.faire.com/fastly/c0c7df422f1a1c0deae7814cecacb05d0950bc9c4cb160fcab768b1b5f30e2d3.jpeg",
    "https://cdn.faire.com/fastly/25e20b9711167b740370c0716ed66c29451d8f72aba09bb0a89038a950f919d2.jpeg",
  ],
  priceDollars: 13.85,
  description:
    "✔️ Vegan ✔️ Cruelty Free ✔️ No Synthetics\nWant moisture? Drop the watered down lotion and pick up our Luxe Body Oil. Perfect for daily use on your face, body and even your hair! Also makes a great massage oil, always a plus right?\n\nThe natural oils in this bad boy are rich in Vitamin E and anti-oxidants so they make for a skincare, must-have!\nIngredients \nRice Bran Oil, Sweet Almond Oil, Jojoba Oil and a blend of essential oils. \nDirection\nUse desired amount on skin, hair and nails. Luxe Body Oil is face, body and family friendly.\n\n*Please note, the 2oz travel size comes with a cap, not a pump. \n\nUntamed Naturals does not make any medical claims. Please read ingredients before using. Always store natural products in a cool and dry place.",
  tags: [],
  msrpDollars: 27.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:17.141Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
